import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import TeleworkLayout from "../../components/teleworklayout"
import TeleworkSEO from "../../components/teleworkseo"

import "../../style/main.scss"

import TeleworkSubNav from "../../components/teleworksubnav"
import TeleworkAbout from "../../components/teleworkabout"
import TeleworkSpeakers from "../../components/teleworkspeakers"
import TeleworkAgenda from "../../components/teleworkagenda"
import TeleworkJoinus from "../../components/teleworkjoinus"
import Location from "../../components/location"



const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <TeleworkLayout>
      <TeleworkSEO title="Telework Live 2020 | July" />
      <TeleworkSubNav />
      <TeleworkAbout sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      <TeleworkSpeakers speakers={speakers} />
      <TeleworkAgenda sessions={sessions} speakers={speakers} />
      <TeleworkJoinus />
      
    </TeleworkLayout>
  )
}

export default IndexPage